module.exports = __webpack_public_path__ + "media/images/sp/stores/shinjuku/shinjuku_sns_01-6a6fbdb657f67b98c869765c753041ca.jpg";